import { ArrowRight } from '@brainpool/icon-pack';
import { Box, Card, Typography, useTheme } from '@mui/material';

interface WidgetAction {
  filter?: string;
}

export interface WidgetProps {
  title: string;
  icon?: React.ReactNode;
  description: string;
  action?: WidgetAction;
  active?: boolean;
  onClick?: () => void;
}

export function Widget({ title, icon, description, onClick, active = false }: WidgetProps) {
  const theme = useTheme();
  return (
    <Card
      data-testid="widget-card"
      onClick={onClick}
      sx={{
        px: 2,
        py: 1,
        cursor: onClick ? 'pointer' : 'default',
        flexGrow: 1,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        border: '2px solid',
        borderColor: active ? 'success.main' : 'transparent',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h4" onClick={onClick}>
          {title}
        </Typography>
        {icon && <Box>{icon}</Box>}
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ py: 1, pb: 2 }}>
        {description}
      </Typography>

      <Box
        sx={{
          textAlign: 'right',
          alignSelf: 'flex-end',
          mt: 'auto',
          transform: 'rotate(90deg)',
        }}
      >
        <ArrowRight fill={theme.palette.warning.contrastText} />
      </Box>
    </Card>
  );
}

export default Widget;
